var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.mode === "small" ? "gallery gallery--left" : "gallery" },
    _vm._l(_vm.galleryItems, function(item, index) {
      return _c(
        "li",
        {
          key: item.id,
          class:
            _vm.mode === "small"
              ? "gallery__item gallery__item--small"
              : "gallery__item"
        },
        [
          _c("Photoswipe", {
            attrs: { "gallery-items": _vm.galleryItems, gid: _vm.gid },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var openGallery = ref.openGallery
                    return [
                      _c(
                        "button",
                        {
                          class:
                            _vm.mode === "small"
                              ? "gallery__image-wrap gallery__image-wrap--small"
                              : "gallery__image-wrap",
                          on: {
                            click: function($event) {
                              return openGallery(index)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "gallery__image",
                            attrs: { src: item.thumbnail }
                          })
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }